export enum AchTab {
    OneTime = 'One-Time',
    Recurring = 'Recurring',
    RecipientActivity = 'Recipient-Activity',
    Templates = 'Templates',
}
